export default "__VITE_ASSET__f9ec4863__"